<div class="modal-header">
    <h3 class="modal-title">
        <strong>View/Edit Reportable Transaction</strong>
        <div class="header-actions">
            <i class="fa" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" 
               style="cursor: pointer;" (click)="minimise = !minimise"></i>
            <i class="fa fa-times" style="cursor: pointer;" (click)="cancel()"></i>
        </div>
    </h3>
</div>

<div class="modal-body" [hidden]="minimise">
    <!-- Loading spinner -->
    @if (loadingData) {
<div class="text-center" style="padding: 20px;">
        <i class="fa fa-spinner fa-spin fa-2x"></i>
        <p>Loading...</p>
    </div>
}

    @if (!loadingData) {
<div>
        <div class="row" style="width: 100%; text-align: center; border: 0px;">
            <h4>M3 Reclass for Reportable Transaction (Column A)</h4>
        </div>

        <!-- Message when Schedule D transaction is not saved -->
        @if (dataRow?.IS_EDITTED === 'Y') {
<div>
            <div class="row" style="width: 100%; text-align: center; border: 0px;">
                <h4>Please save the Schedule D Transaction to enter the Reportable Details</h4>
            </div>
        </div>
}

        <!-- Main form when editted is N -->
        @if (dataRow?.IS_EDITTED === 'N') {
<div>
            <div class="row" style="margin: 5px;">
                <div class="col-md-3">
                    <label>Reportable Action</label>
                    <select class="form-control"
                            [(ngModel)]="repTransHeader.REPORTABLE_ACTION"
                            (change)="reportableactionchange()">
                        <option value="">-- Select Reportable Action --</option>
                        @for (type of ReporatableActions; track $index) {
<option [value]="type.CODE_DESC">
                            {{ type.CODE_DESC }}
                        </option>
}
                    </select>
                </div>
                <div class="col-md-3">
                    <label>Reportable Tax Amount</label>
                    <div class="input-group">
                        <span class="input-group-addon">USD</span>
                        <input type="number" style="text-align: right" class="form-control"
                               [(ngModel)]="repTransHeader.REP_TAX_AMT"
                               (change)="reportabletaxamountchange()">
                        <span class="input-group-addon">
                            <button type="button" style="border: none; padding: 0; background: none;"
                                    (click)="applyTaxacct()">Apply</button>
                        </span>
                    </div>
                    @if (reportabletaxamountError) {
<span class="form-error-container">
                        Reportable Tax Amount is required
                    </span>
}
                </div>
            </div>
        </div>
}

        <!-- ZBA Section -->
        @if (repTransHeader.ADJ_SOURCE === 'ZBA') {
<div>
            <div class="row" style="margin: 5px;">
                <div class="col-md-12">
                    <label>Reason for Zero Book Amount: </label>
                    <input class="form-control"
                           [(ngModel)]="repTransHeader.HEADER_COMMENTS"
                           (change)="updatereasonforZBA()">
                    @if (reasonforzeroError) {
<span class="form-error-container">
                        Reason for Zero Book Amount is required
                    </span>
}
                </div>
            </div>

            <div class="row" style="margin: 5px;">
                <div class="col-md-6">
                    <label>Reportable Transaction Description as per Form 8886, Line 1a: </label>
                    <input class="form-control"
                           [(ngModel)]="repTransHeader.ADJ_DESC"
                           (change)="updateTransDesc()">
                    @if (rptdescError) {
<span class="form-error-container">
                        Reportable Transaction Description as per Form 8886, Line 1a is required
                    </span>
}
                </div>
                <div class="col-md-4">
                    <label>Tax Shelter Registration Number </label>
                    <input class="form-control"
                           [(ngModel)]="repTransHeader.ADJ_ORIGIN_SOURCE">
                </div>
                <div class="col-md-2">
                    <label>Type of Reportable Transaction </label>
                    <select class="form-control"
                            [(ngModel)]="repTransHeader.REASON_REPORTABLE"
                            (change)="updateRepType()">
                        <option value="">-- Select --</option>
                        @for (type of ReporatableReasonTypes; track $index) {
<option [value]="type.CODE_DESC">
                            {{ type.CODE_DESC }}
                        </option>
}
                    </select>
                    @if (typeofrptError) {
<span class="form-error-container">
                        Please Select Type of Reportable Transaction
                    </span>
}
                </div>
            </div>
        </div>
}

        <!-- DP Section -->
        @if (repTransHeader.ADJ_SOURCE === 'DP') {
<div>
            <div class="row" style="margin: 5px;">
                <div class="col-md-6">
                    <label>Reportable Transaction Description as per Form 8886, Line 1a: </label>
                    <input class="form-control"
                           [(ngModel)]="repTransHeader.ADJ_DESC"
                           (change)="updateTransDesc()">
                    @if (rptdescError) {
<span class="form-error-container">
                        Reportable Transaction Description as per Form 8886, Line 1a is required
                    </span>
}
                </div>
                <div class="col-md-4">
                    <label>Tax Shelter Registration Number </label>
                    <input class="form-control"
                           [(ngModel)]="repTransHeader.ADJ_ORIGIN_SOURCE">
                </div>
                <div class="col-md-2">
                    <label>Type of Reportable Transaction </label>
                    <select class="form-control"
                            [(ngModel)]="repTransHeader.REASON_REPORTABLE"
                            (change)="updateRepType()">
                        <option value="">-- Select --</option>
                        @for (type of ReporatableReasonTypes; track $index) {
<option [value]="type.CODE_DESC">
                            {{ type.CODE_DESC }}
                        </option>
}
                    </select>
                    @if (typeofrptError) {
<span class="form-error-container">
                        Please Select Type of Reportable Transaction
                    </span>
}
                </div>
            </div>
        </div>
}

        <!-- BAA Section (Book Adjustment Action) -->
        @if (repTransHeader.ADJ_SOURCE === 'BAA') {
<div>
            <div class="row" style="margin: 5px;">
                <div class="col-md-6">
                    <label>Reportable Transaction Description as per Form 8886, Line 1a: </label>
                    <input class="form-control"
                           [(ngModel)]="repTransHeader.ADJ_DESC"
                           (change)="updateTransDesc()">
                    @if (rptdescError) {
<span class="form-error-container">
                        Reportable Transaction Description as per Form 8886, Line 1a is required
                    </span>
}
                </div>
                <div class="col-md-4">
                    <label>Tax Shelter Registration Number </label>
                    <input class="form-control"
                           [(ngModel)]="repTransHeader.ADJ_ORIGIN_SOURCE">
                </div>
                <div class="col-md-2">
                    <label>Type of Reportable Transaction </label>
                    <select class="form-control"
                            [(ngModel)]="repTransHeader.REASON_REPORTABLE"
                            (change)="updateRepType()">
                        <option value="">-- Select --</option>
                        @for (type of ReporatableReasonTypes; track $index) {
<option [value]="type.CODE_DESC">
                            {{ type.CODE_DESC }}
                        </option>
}
                    </select>
                    @if (typeofrptError) {
<span class="form-error-container">
                        Please Select Type of Reportable Transaction
                    </span>
}
                </div>
            </div>

            <!-- BAA Table Header -->
            <div class="row" style="margin: 15px;">
                <div class="col-md-1"></div>
                <div class="col-md-3">
                    <label>G/L Account</label>
                </div>
                <div class="col-md-2">
                    <label>CY Amount</label>
                </div>
                <div class="col-md-2">
                    <label>Earlier Adjustments Amount</label>
                </div>
                <div class="col-md-2">
                    <label>Adjustments Amount</label>
                </div>
                <div class="col-md-2">
                    <label>Adjusted CY Amount</label>
                </div>
            </div>

            <!-- BAA Table Rows -->
            @for (repTrans of repTransDetails; track trackByIndex(i, repTrans); let i = $index) {
<div class="row" style="margin: 5px;" 
                >
                <div class="col-md-1">
                    <br>
                    <i style="font-size: 24px; cursor: pointer;"
                       class="fa fa-minus-circle color-red"
                       title="Mark Role for Deletion"
                       (click)="removeportable(i)"></i>
                </div>

                <div class="col-md-3">
                    <select class="form-control"
                            [(ngModel)]="repTrans.GL_ACCT_DESC"
                            (change)="getAccountAmtData(i, repTrans.ACCT_DESC)">
                        <option value="">-- Select Account --</option>
                        @for (acct of AccountList; track $index) {
<option 
                                [value]="acct.GL_ACCT"
                                [hidden]="acct.SELECTEDACCT === 1">
                            {{ acct.GL_ACCT }}
                        </option>
}
                    </select>
                    @if (ACCT_KEY_ERROR) {
<span class="form-error-container">
                        Please Select a G/L Account
                    </span>
}
                </div>

                <div class="col-md-2">
                    @if (repTrans.AMT_LOADING) {
<div class="text-center">
                        <i class="fa fa-spinner fa-spin"></i>
                    </div>
}
                    @if (!repTrans.AMT_LOADING) {
<input 
                           type="number" style="text-align: right" class="form-control"
                           [(ngModel)]="repTrans.CY_AMOUNT" readonly>
}
                </div>

                <div class="col-md-2">
                    @if (repTrans.AMT_LOADING) {
<div class="text-center">
                        <i class="fa fa-spinner fa-spin"></i>
                    </div>
}
                    @if (!repTrans.AMT_LOADING) {
<input
                           type="number" style="text-align: right" class="form-control"
                           [(ngModel)]="repTrans.EARLY_ADJ_AMT" readonly>
}
                </div>

                <div class="col-md-2">
                    <input type="number" style="text-align: right" class="form-control"
                           [(ngModel)]="repTrans.REP_TRANS_AMT"
                           (blur)="updateAmount(i)">
                    @if (RECLASS_ADJ_AMT_ERROR) {
<span class="form-error-container">
                        Adjustments amount cannot be zero
                    </span>
}
                </div>

                <div class="col-md-2">
                    <input type="number" style="text-align: right" class="form-control"
                           [(ngModel)]="repTrans.ADJUSTED_CY_AMOUNT" readonly>
                </div>
            </div>
}

            <!-- Add Row and Target Account Row -->
            <div class="row" style="margin: 5px;">
                <div class="col-md-1">
                    @if (enableAddRow) {
<i
                       style="font-size: 24px; cursor: pointer;"
                       class="fa fa-plus-circle color-green"
                       title="Add Account"
                       (click)="addReportable()"></i>
}
                </div>

                <div class="col-md-3">
                    <input class="form-control"
                           [(ngModel)]="targetAcct" readonly>
                </div>
                <div class="col-md-2">
                    <input type="number" style="text-align: right" class="form-control"
                           [(ngModel)]="targetCYAmount" readonly>
                </div>
                <div class="col-md-2">
                    <input type="number" style="text-align: right" class="form-control"
                           [ngModel]="priorReportableAdjustment[0]?.EARLY_ADJ_AMT" readonly>
                </div>
                <div class="col-md-2">
                    <input type="number" style="text-align: right" class="form-control"
                           [(ngModel)]="targetAdjustmentAmt" readonly>
                </div>
                <div class="col-md-2">
                    <input type="number" style="text-align: right" class="form-control"
                           [(ngModel)]="targetAdjCYAmount" readonly>
                </div>
            </div>
        </div>
}
    </div>
}
</div>

<div class="modal-footer" [hidden]="minimise">
    <button class="btn btn-info btn-sm" type="button" 
            [disabled]="!isValidScenario || crudLoading" 
            (click)="save()">
        @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
    </button>
    <button class="btn btn-warning btn-sm" type="button" (click)="cancel()">Cancel</button>
</div>
